// document.addEventListener("DOMContentLoaded", function () {

//   function setFooterPadding() {
//     const footerInner = document.querySelector('.footer-main-wp');
//     const footerSection = document.querySelector('.shopify-section-footer');

//     if (!footerInner || !footerSection) return;

//     const footerHeight = footerInner.offsetHeight;
//     footerSection.style.paddingTop = footerHeight + "px";
//   }

//   setFooterPadding();

//   window.addEventListener("resize", setFooterPadding);

//   const footer = document.querySelector(".footer-main-wp");
//   if (footer){
//     function scrollToBottom() {
//       window.scrollTo({
//         top: document.documentElement.scrollHeight,
//         behavior: "smooth"
//       });
//     }
//     const observer = new MutationObserver((mutationsList) => {
//       setFooterPadding();
//       setTimeout(() => {
//         scrollToBottom();
//       }, 100);
//     });

//     observer.observe(footer, {
//       childList: true,    
//       subtree: true,      
//       attributes: true,   
//       characterData: true 
//     });
//   }

//   // -------------------     Header Logo -------------------

//   function toggleLogo() {
//     if (window.scrollY > 0) {
//       document.body.classList.add("animate-logo");
//     } else {
//       document.body.classList.remove("animate-logo");
//     }
//   }

//   toggleLogo();
//   window.addEventListener("scroll", toggleLogo);

// });

document.addEventListener("DOMContentLoaded", function () {

  /* ---------------- Footer Padding ---------------- */

  function setFooterPadding() {
    const footerInner = document.querySelector('.footer-main-wp');
    const footerSection = document.querySelector('.shopify-section-footer');

    if (!footerInner || !footerSection) return;

    const footerHeight = footerInner.offsetHeight;
    footerSection.style.paddingTop = footerHeight + "px";
  }

  function scrollToBottom() {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth"
    });
  }

  const footer = document.querySelector(".footer-main-wp");

  if (footer) {
    const detailsElements = footer.querySelectorAll("details");

    detailsElements.forEach(details => {
      details.addEventListener("toggle", function () {

        setFooterPadding();

        // Only scroll when opened
        if (details.open) {
          setTimeout(() => {
            scrollToBottom();
          }, 200); // small delay for smooth animation
        }
      });
    });
  }

  window.addEventListener("resize", setFooterPadding);
  setFooterPadding();


  /* ---------------- Header Logo Animation ---------------- */

  function toggleLogo() {
    if (window.scrollY > 0) {
      document.body.classList.add("animate-logo");
    } else {
      document.body.classList.remove("animate-logo");
    }
  }

  toggleLogo();
  window.addEventListener("scroll", toggleLogo);

});